export default "__VITE_ASSET__By5VX4QG__"